<template>
  <div style="width:100%; min-height: 100vh;background-color: #f0f2f5;">
    <header>
      <h1 style="font-size: 20px;"> 教师评教页面</h1>

    </header>

    <div style="width: 100% ; margin-top: 20px;" >
      <el-form v-model="form" :inline="true">
        <el-form-item label="考试列表" prop="examId" style="width:60%">
          <el-select v-model="form.examId" filterable placeholder="考试列表"  @change="getExam()" style="width: 500px;">
              <el-option v-for="item in examList" :key="item.id" :label="item.name" :value="item.id">
                {{ item.name }} ( {{ item.id }})
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <!-- <div class="button-container"> -->
            <el-button 
                v-for="(item, index) in chartType" 
                :key="index"
                type="primary"
                @click="chartTypeShow(item)"
              >
                {{ item.name }}
              </el-button>

          <!-- </div> -->
        </el-form-item>
      </el-form>
    </div>

    <!-- 图表内容处 -->


    <div style="width: 100%; overflow-y: auto;"  v-if="checkChart == 'indicatorCompare' || checkChart == 'step10Compare'  ">
      <span v-if="configHard.length == 0"> 该考试不包含配置的行政班，请检查行政班是否配置正确</span>
      <div  v-else  class="charts-grid">
        <div  v-for="(classItem, index) in chartList" :key="index" class="chart-card">
          <el-button type="text" icon="el-icon-full-screen"  class="chart-full-btn"  @click="openFull(index,1)">全屏</el-button>
          <div :ref="`chart_${index}`" class="chart"></div>
        </div>
      </div>
    </div>

    <!-- <div ref="chart" style="width: 100%; height: 80vh;" v-if=" checkChart == 'scoreStatistics'"></div> -->

    <div  style="width: 100%;  overflow-y: auto;" v-if="checkChart == 'scoreStatistics' ">
      <span v-if="configHard.length == 0"> 该考试不包含配置的行政班，请检查行政班是否配置正确</span>
      <div v-else  class="charts-grid">   
        <div  v-for="(classItem, index) in chartList" :key="index" class="chart-card">
          <el-button type="text" icon="el-icon-full-screen" class="chart-full-btn" @click="openFullScreenAndDialog(index,classItem.hardName)">全屏</el-button>
          <div :ref="`chart_${index}`" class="chart"></div>
        </div>
      </div>
    </div>


      <!-- :header-cell-style="{ textAlign: 'center' }" -->
      <el-table :data="tableData" :row-style="rowStyle" v-if="checkChart == 'kgStatistics2' "  :cell-style="{ textAlign: 'center' }"  style="margin-top: 25px">
        <el-table-column prop="name" label="题序" width="120px">
          <template slot-scope='scope'>
            <span class="label">第 {{ scope.row.ix }} 题</span>
          </template>
        </el-table-column>
        <el-table-column :label= tableName >
          <template slot-scope='scope'>
            <!-- <div v-for="(item, index) in scope.row.answers" :key="index">
                {{ key }}: {{ value }}
            </div> -->
            <div v-for="(item, index) in scope.row.answers" :key="index"  class="progress-row">
              <span class="label">{{ item.anw }}:</span>
              <el-progress
                :percentage="item.count" 
                :format="() => `${item.count}个`"
                :text-inside="false"
                :stroke-width="15" 
                style="width: 80%"
                :color="getProgressColor(item.count)"
              ></el-progress>
            </div>

          </template>
        </el-table-column>

      </el-table>

      <div v-if="checkChart == 'kgStatistics' ">
        <span v-if="configHard.length == 0"> 该考试不包含配置的行政班，请检查行政班是否配置正确</span>
        <div v-else>
          <el-tabs type="border-card" v-model="activeTab" class="large-tab">
            <el-tab-pane 
              v-for="item in configHard" 
              :key="item.hard_class_id"
              :label="item.hard_name"
              :name="item.hard_name"
            >
            <div style="display: flex; gap: 20px; align-items: flex-start;">

           
            <!-- 客观题部分 -->
              <el-table :data="item.kgData" :row-style="rowStyle" v-if="checkChart == 'kgStatistics' "  :cell-style="{ textAlign: 'center' }"  style="margin-top: 25px">
                <el-table-column prop="name" label="题序" width="120px">
                  <template slot-scope='scope'>
                    <span class="label">第 {{ scope.row.ix }} 题</span>
                  </template>
                </el-table-column>
                <el-table-column label="客观题统计情况"  >
                  <template slot-scope='scope'>
                    <!-- <div v-for="(item, index) in scope.row.answers" :key="index">
                        {{ key }}: {{ value }}
                    </div> -->
                    <div v-for="(item, index) in scope.row.answers" :key="index"  class="progress-row">
                      <span class="label-kg ">{{ item.anw }}:</span>
                      <el-progress
                        :percentage="item.count" 
                         :format="() => formatNumber(item.count)"
                        :text-inside="false"
                        :stroke-width="15" 
                        style="width: 80%"
                        :color="getProgressColor(item.count)"
                      ></el-progress>
                    </div>

                  </template>
                </el-table-column>
              </el-table>

              <!-- 主观题部分 -->
              <el-table :data="item.zgData" :row-style="rowStyle" v-if="checkChart == 'kgStatistics' "  :cell-style="{ textAlign: 'center' }"  style="margin-top: 25px">
                <el-table-column prop="name" label="题序" width="120px">
                  <template slot-scope='scope'>
                    <span class="label">第 {{ scope.row.ix }} 题</span>
                    <div v-if="titleList != {}">
                      <span style="font-size: 8px;">( {{ getTitleName(scope.row) }} )</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label= "主观题统计情况" >
                  <template slot-scope='scope'>

                    <!-- 步长 -->
                    <span style="margin-right: 10px;">步长</span>
                    <el-select v-model="scope.row.step" placeholder="请选择分数步长" @change="changeZgScore(scope.row,2)">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>

                    <!-- 主观题数据 -->
                    <div v-for="(item, index) in scope.row.answers" :key="index"  class="progress-row">
                      <span class="label-zg " style="margin-right: 10px;">{{ item.anw }}:</span>
                      <el-progress
                        :percentage="item.count" 
                        :format="() => formatNumber(item.count)"
                        :text-inside="false"
                        :stroke-width="15" 
                        style="width: 80%"
                        :color="getProgressColor(item.count)"
                      ></el-progress>
                    </div>

                  </template>
                </el-table-column>
              </el-table>

            </div>

            </el-tab-pane>
         </el-tabs>

        </div>


      </div>


      <!-- 班级综合分析 -->
       <div v-show="checkChart == 'comprehensiveAnalysis' ">
        <span v-if="configHard.length == 0"> 该考试不包含配置的行政班，请检查行政班是否配置正确</span>
        <div v-else  class="container">


            <!-- 标题 -->
            <div class="header-title">
                <div class="tag-title">第一层</div>
                <h1 class="main-title">整场考试画像（宏观决策）</h1>
            </div>

            <!-- 内容 -->

            <div class="card-row">
                <div
                    class="stat-card"
                    :class="item.className"
                    v-for="item in cardGradeList"
                    :key="item.title"
                >
                    <div class="card-title">{{ item.title }}</div>
                    <div class="card-value">{{ item.value }}</div>
                    <div class="card-desc" :class="{ red: item.isRed }">
                    {{ item.desc }}
                    </div>
                </div>
            </div>



            <div class="header-title">
                <div class="tag-title">第二层</div>
                <h1 class="main-title">班级质量分析</h1>
            </div>

            <!-- {{ configHard }} -->

            <el-tabs type="border-card" v-model="activeTabClass"  @tab-click="handleTabClick" class="large-tab" >
              <el-tab-pane 
                v-for="item in configHard" 
                :key="item.hard_class_id"
                :label="item.hard_name"
                :name="item.hard_name"
              >
              <div style="display: flex; gap: 20px; align-items: flex-start;"></div>

              <div class="card-row">
                <div
                    class="stat-card"
                    :class="item.className"
                    v-for="item in cardClassList"
                    :key="item.title"
                >
                    <div class="card-title">{{ item.title }}</div>
                    <div class="card-value">{{ item.value }}</div>
                    <div class="card-desc" :class="{ red: item.isRed }">
                    {{ item.desc }}
                    </div>
                </div>
              </div>


              </el-tab-pane>
            </el-tabs>

            <!-- 图表 -->
            <div class="chart-row">

                <!-- 成绩分布直方图 -->
                <div class="chart-card">
                  
                    <h3 class="chart-title">成绩分布直方图</h3>
                    <el-button type="text" icon="el-icon-full-screen"  class="chart-full-btn"  @click="openFull('score',2)">全屏</el-button>
                    <div ref="score" class="chart-container"></div>
                </div>

                <!-- 学业等级结构 -->
                <div class="chart-card">
                    <h3 class="chart-title">学业等级结构（A/B/C/D/E）</h3>
                    <el-button type="text" icon="el-icon-full-screen"  class="chart-full-btn"  @click="openFull('studentLevel',2)">全屏</el-button>
                    <div ref="studentLevel" class="chart-container"></div>
                </div>

            </div>


            <div  class="chart-row">
                <div class="chart-card-full">
                  <el-button type="text" icon="el-icon-full-screen"   style="float: right; margin-left: 10px;z-index: 10; background: rgba(255,255,255,0.9);  border-radius: 4px;"  @click="openFull('compare',2)">全屏</el-button>
                    <h3 class="chart-title">与年级对比分析</h3>
                    
                    <div ref="compare" class="chart-container"></div>
                </div>
            </div>



          </div>
                
      
      
      
      
      
      
      
      </div>


      <!-- 图表全屏弹窗 -->
      <el-dialog fullscreen :visible.sync="fullScreenVisible"  top="0"  show-close   close-icon="关闭" >

        <div v-if="this.checkChart == 'scoreStatistics'" >
          <el-button type="primary" @click="typicalTopic" style="margin-left: 50%;">典型错题(得分率最低十题)</el-button>
          <div ref="fullChartRef" style="width:100%;min-height:200vh;"></div>
        </div>
        <div v-else>
          <div ref="fullChartRef" style="width:100%;min-height:100vh;"></div>
        </div>
        


      </el-dialog>

      <!-- 得分率点击显示对应题块的选择题选项 -->
       <el-dialog :visible.sync="topicStatisticsVisible" width="20%" :title="topicTitle">
        <el-table :data="topicData" :row-style="rowStyle">
          <!-- <el-table-column label="序号" width="70" prop="id" /> -->
          <el-table-column label= "统计情况" >
            <template slot-scope='scope'>
              <div v-for="(item, index) in scope.row.answers" :key="index"  class="progress-row">
                <span class="label">{{ item.anw }}:</span>
                <el-progress
                  :percentage="item.count" 
                  :format="() => `${item.count}个`"
                  :text-inside="false"
                  :stroke-width="15" 
                  style="width: 80%"
                  :color="getProgressColor(item.count)"
                ></el-progress>
              </div>

            </template>
          </el-table-column>
        </el-table>


       </el-dialog>



  
  </div>



</template>

<script>
  import comprehensiveAnalysis from './comprehensiveAnalysis'
  import test from './test'
  import {mapGetters, mapState} from "vuex";
  import * as simpleApi from "request/simple";
  import XEUtils from 'xe-utils'
  import * as mUtils from '@/utils/mUtils'
  import * as echarts  from 'echarts';
  import { ref } from 'vue'


  export default {
      name: 'teacherDialog',
      data(){
          return {
            isFull: true,
            // json 文件中过滤出的中行政班
            hardClassList:[],
            // 老师配置的总的行政班(读取老师旗下指定课程的行政班列表)
            hardClassConfig:[],
            // 过滤后该老师在这场考试的的行政班
            configHard:[],
            hardClassList2:["23动漫2班", "23珠宝班","23设计2班","23设计3班"],
            // courseList:["形式政策"],
            courseList:[],
            // 图表类型
            chartType: [{
              type: 'comprehensiveAnalysis',
              name:"班级综合分析"
            },{
              type: 'indicatorCompare',
              name:"各类指标比对表"
            },{
              type: 'step10Compare',
              name:"分数段比较表"
            },{
              type: 'kgStatistics',
              name:"每题得分统计"
            },{
              type: 'scoreStatistics',
              name:"得分率比较表"
            }],
            scoreRange: ['优秀','良好','中等','及格','不及格'], 
            scoreLevels: {
              score90: {name: '优秀', from: 90, to: 100}, 
              score80: {name: '良好', from: 80, to: 90},
              score70: {name: '中等', from: 70, to: 80},
              score60: {name: '及格', from: 60, to: 70}, 
              score0: {name: '不及格', from: 0, to: 60},
            },
            jsonData: null,
            // 班级统计信息
            hardClassStatistics: null,
            // 选中课程
            course: null,
            // 选中班级
            hard: {
              hardName: null,
              index: 0
            },
            step10List:[],
            tableData2:[],
            tableData: [
              { 
                name: '华北地区', 
                sales: [
                  { name: '产品A', value: 150 },
                  { name: '产品B', value: 200 },
                  { name: '产品C', value: 120 }
                ]
              },
              { 
                name: '华东地区', 
                sales: [
                  { name: '产品A', value: 180 },
                  { name: '产品B', value: 160 },
                  { name: '产品C', value: 140 }
                ]
              }
            ],
            test:[{
              anw: 'A',
              count:5
            },{
              anw: 'B',
              count:1
            },{
              anw: 'C',
              count:0
            },{
              anw: 'D',
              count:9
            },],
            // 选中图表
            checkChart: null,
            tableName: null,
            jsonHardData: null,
            treeProps: {
              label: 'name',
              children: 'children',
              isLeaf: 'leaf'
            },
            // 考试列表
            examList:[],
            form:{
              examId: null
            },
            chartList:[],
            activeTab: null,

            // 全屏需要的变量
            fullScreenVisible: false,
            fullChart: null, // 全屏图表实例
            currentFullIndex: -1, // 当前全屏的索引
            // 全屏数据
            fullData:{},
            options: [{
              value: '2',
              label: '2分'
            }, {
              value: '5',
              label: '5分'
            }, {
              value: '10',
              label: '10分'
            }, {
              value: '15',
              label: '15分'
            }, {
              value: '20',
              label: '20分'
            }],
            value: '',
            // 主观题默认步长
            stepSize: 5,
            // 题型
            topicStatisticsVisible: false,
            topicData:[],
            topicTitle: null,
            // 题型数量颜色对照
            progressColors: [
              '#B5E69F',   // 0-10
              '#96D9F0',   // 11-20
              '#AFC8F5',   // 21-30
              '#E6B3E6',   // 31-40
              '#F5B8B2',   // 41-50
              '#D8D8D8',   // 51-60
              '#A6E3D7',   // 61-70
              '#C8BAF5',   // 71-80
              '#FFD49E',   // 81-90
              '#AFC6E5'    // 91-100
            ],
            // 题目列表
            titleList:{},
            // 班级卡片信息
            cardGradeList: [{
                title: "年段均分",
                value: null,
                desc: null,
                className: "card-blue",
                isRed: true
            },
            {
                title: "年段最高分",
                value: null,
                desc: null,
                className: "card-green",
                isRed: false
            },
            {
                title: "年段最低分",
                value:null,
                desc: null,
                className: "card-red",
                isRed: true
            },
            {
                title: "年段标准差",
                value: null,
                desc: null,
                className: "card-blue",
                isRed: false
            },
            {
                title: "年段及格率",
                value: null,
                desc: null,
                className: "card-yellow",
                isRed: true
            },
            {
                title: "年段优秀率（≥90）",
                value: null,
                desc: null,
                className: "card-green",
                isRed: false
            }
            ],
            cardClassList: [{
                title: "班级均分",
                value: null,
                desc: null,
                className: "card-blue",
                isRed: true
            },
            {
                title: "班级最高分",
                value: null,
                desc: null,
                className: "card-green",
                isRed: false
            },
            {
                title: "班级最低分",
                value:null,
                desc: null,
                className: "card-red",
                isRed: true
            },
            {
                title: "班级标准差",
                value: null,
                desc: null,
                className: "card-blue",
                isRed: false
            },
            {
                title: "班级及格率",
                value: null,
                desc: null,
                className: "card-yellow",
                isRed: true
            },
            {
                title: "班级优秀率（≥90）",
                value: null,
                desc: null,
                className: "card-green",
                isRed: false
            }
            ],

            // 班级综合分析选中
            activeTabClass: null,
            // 过滤年段信息
            gradInfo:{},
            // 过滤班级信息
            classInfo:{}
  

          }
      },
      components:{
        comprehensiveAnalysis,test
      },
      computed:{
          ...mapState({
              userInfo: state => state.user.userInfo,
          }),
      },
      mounted() {
       
      },
      props: {

      },
      watch: {
         
      },
      created(){
        this.loadMyClassList()
        this.loadExamList()
       },
      methods: {
        // 全屏显示
        fullScreen(){
          this.isFull = true
        },
        // 普通显示
        normalScreen(){
          this.isFull = false
        },
        // 选中考试后 查找指定json的数据
        getExam(){
          let examId = this.form.examId
          this.activeTab = null
          // this.activeTabClass = null
          this.checkChart = null

          let analyse_oss_name = "answer/analyse/" + examId + '/exam_analyse_' + examId + '.json'
          this.loadExamCtrl(analyse_oss_name)
          // 获取题号信息
          this.getScantron()

        },
        // 获取analyse.json并解析
        loadExamCtrl(analyse_oss_name, callback){
          // analyse_oss_name = "answer/analyse/310/exam_analyse_310.json"
          // analyse_oss_name = "answer/analyse/2883/exam_analyse_2883.json"

          if(analyse_oss_name != null){
              analyse_oss_name = window.g.OSS_HOST + analyse_oss_name;
          }

          this.loading = true;
          let that = this;
          axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
          axios({
              method:'get',
              url: `${analyse_oss_name}?t=${Date.now()}`
            }).then((res)=>{
              // debugger
                this.jsonData = res.data
                let data = res.data;
                // 年段平均分
                // let gradeAvg = data.score_avg
                
                // 年段总分
                let gradeFullScore = data.full_score
                // 每个班级各分数段列表(平均，优秀...)
                let hard_score_count = data.hard_score_count
                // 每个班级统计数据（包含最高分，最低分，各分数段等）
                let hard_scores =data.hard_scores

                // 整合分数框架
                this.getScoreLevels(gradeFullScore)
                // 根据总分，10分一阶段
                this.getStep10List(gradeFullScore)

                // 获取该考试总的行政班信息
                this.getInfo(hard_scores)

                // this.tableData = data.scores

                // 过滤此老师名下的行政班
                this.filterHardClassConfig()
                // 过滤班级信息
                this.filterGrade()

                this.loadingTiJson()
                if(callback) callback()
                else that.loading = false;


            }).catch((error) => {
                that.loading = false;
            });

        },
        // 计算
        getInfo(hardScores){
       
          // 针对每个班级整合统计信息
          let hardClass = []
          hardScores.forEach((item,index) => {

            // 获取班级信息
            let hardName = item['hardName']
            hardClass.push({
              hardName: hardName,
              index: index
            })
            // 根据获得每个等级的人数
            let scores = item.scores
            let level = this.getScoreNums(item)
            item.scoreLevels = level

          });

          this.hardClassList = hardClass

          console.log("hardClassList==>",hardClass);
          

          this.hardClassStatistics = hardScores
        },
        // 利用总分算30%的区间
        getScoreLevels(totalScore){
          // 基础框架
          let scoreForm = this.scoreLevels;
          scoreForm.score0.from = 0
          scoreForm.score0.to = Math.ceil(totalScore*0.6)
          scoreForm.score60.from = Math.ceil(totalScore*0.6)
          scoreForm.score60.to = Math.ceil(totalScore*0.7)
          scoreForm.score70.from = Math.ceil(totalScore*0.7)
          scoreForm.score70.to = Math.ceil(totalScore*0.8)
          scoreForm.score80.from = Math.ceil(totalScore*0.8)
          scoreForm.score80.to = Math.ceil(totalScore*0.9)
          scoreForm.score90.from = Math.ceil(totalScore*0.9)
          scoreForm.score90.to = totalScore+1
        },
        getStep10List(totalScore) {

          let size = 10
          let segments = [];
          for (let i = 0; i < totalScore; i += size) {
            let start = i;
            let end = i + size;
            segments.push(`${start}-${end}`);
          }
          this.step10List = segments
        },
        // 排序不同等级的人数
        getScoreNums(item){
          let scoreLevels = this.scoreLevels 
          let scores = item.scores
          let level = []
          Object.keys(scoreLevels).forEach(key => {
              // console.log('键:', key);
              // console.log('值:', scoreLevels[key]);
              let form = scoreLevels[key].from
              let to = scoreLevels[key].to
              let count = 0
              scores.forEach(ele => {
                if(ele.score >= form && ele.score < to){
                  count = count + ele.count;
                }
              });
              // 每个等级的人数（当前班级）
              let param = Object.assign({}, scoreLevels[key]);
              param.count = count
              level.push(param)
          });
          return level


        },
        // 过滤配置班级
        filterHardClassConfig(){
          // 将考试json中的行政班与该老师的行政班进行比对，只显示老师配置的行政班
          let configHard = this.hardClassConfig.filter(item1 => 
            this.hardClassList.some(item2 => item2.hardName === item1.hard_name)
          )
          this.configHard = configHard
        },
        // 选中课程
        checkCourse(value){
          this.course = value
          // 选中课程后  查询该老师该课程下的行政班列表
          this.loadMyClassList()

          // this.loadExamCtrl()
        },
        checkHardClass(value){
          this.hard = value
        },
        // 切换标签页
        chartTypeShow(item){
          let chartName = item.type
          this.checkChart = chartName
          if(chartName == 'indicatorCompare'){
            this.indicatorChart()
          }else if(chartName == 'step10Compare'){
            this.step10Chart()
          }else if(chartName == 'kgStatistics'){
            this.kgChart()
          }else if(chartName == 'scoreStatistics'){
            this.scoreStatisticsChart()
          }else if(chartName == 'comprehensiveAnalysis'){
            this.comprehensiveAnalysis()
          }
        },

        // 各类指标对比表
        indicatorChart() {
          // 将考试json中的行政班与该老师的行政班进行比对，只显示老师配置的行政班
          let configHard = this.hardClassConfig.filter(item1 => 
            this.hardClassList.some(item2 => item2.hardName === item1.hard_name)
          )
          this.configHard = configHard
          if(configHard.length == 0)  return 

          let chartList = []
          configHard.forEach((ele,count) => {
            // 过滤每个班级的指标信息
            let hardName = ele.hard_name
            let item = this.hardClassList.find(item => item.hardName == hardName)
            let index = item.index
            let legendHard = hardName + "指标"
            let hardClass = this.hardClassStatistics[index].scoreLevels
            let scoreRange = this.scoreRange
            let gradeScoreLevel = this.jsonData.score_level

            // 根据顺序排列值
            let hardClassSort2 = hardClass.sort((x, y) => {
              return scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
            
            });
            let hardClassSort = hardClass.sort((x, y) => 
                scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
              ).map(item => item.count)

            console.log("排序",hardClassSort);

            
            let gradeSort2 = gradeScoreLevel.sort((x, y) => {
              return scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
            });
            let gradeSort = gradeScoreLevel.sort((x, y) => 
                scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
              ).map(item => item.count)
              
              //this.hard.hardName + '各类指标比对'
              // data: this.scoreRange
              //  data: this.scoreRange
              // name: legendHard,
              // data: gradeSort, 

              let option = {
                index: count,
                hardName: hardName,
                legendHard : legendHard,
                scoreRange: scoreRange,
                gradeSort: gradeSort,
                hardClassSort: hardClassSort
              }
              chartList.push(option)

          })
          this.chartList = chartList
          // 初始化多张图表
          this.initIndicatorChart(chartList)

          // let index = this.hard.index
          // let legendHard = this.hard.hardName + "指标"
          // let hardClass = this.hardClassStatistics[index].scoreLevels
          // let scoreRange = this.scoreRange
          // let gradeScoreLevel = this.jsonData.score_level

          // // 根据顺序排列值
          // let hardClassSort2 = hardClass.sort((x, y) => {
          //   return scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
           
          // });
          // let hardClassSort = hardClass.sort((x, y) => 
          //     scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
          //   ).map(item => item.count)

          // console.log("排序",hardClassSort);

          
          // let gradeSort2 = gradeScoreLevel.sort((x, y) => {
          //   return scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
          // });
          // let gradeSort = gradeScoreLevel.sort((x, y) => 
          //     scoreRange.indexOf(x.name) - scoreRange.indexOf(y.name)
          //   ).map(item => item.count)
          


          // // 初始化图表实例
          // this.chart = echarts.init(this.$refs.chart);
          
          // // 配置项
          // let option = {
          //   title: {
          //     text: this.hard.hardName + '各类指标比对',  // 主标题
          //     // subtext: '2 Data'                 // 副标题
          //   },
          //   // 触发方式：'axis'坐标轴触发，'item'数据项触发
          //   tooltip: {
          //     trigger: 'axis'  
          //   },
          //   // X轴配置
          //   xAxis: [
          //     {
          //       // 类目轴，适用于离散的类目数据
          //       type: 'category',  
          //       // 配置X轴名称
          //       data: this.scoreRange
          //     }
          //   ],
          //   // Y轴配置
          //   yAxis: [
          //     {
          //       // 数值轴，适用于连续数据
          //       type: 'value'  
          //     }
          //   ],
          //   // 图例项，对应series中的name
          //   legend: {
          //     data: [legendHard, '年段指标']  
          //   },
          //   // 数值列表
          //   series: [
          //     {
          //       // 系列名称，与legend对应
          //       name: legendHard,
          //       // 图表类型：柱状图
          //       type: 'bar', 
          //       // 数据数组 
          //       data: hardClassSort,
          //       itemStyle: {
          //         color: '#90cbfb'
          //       },
          //       barGap: '10%', 
          //     },{
          //         name: '年段指标',      
          //         type: 'bar',           
          //         data: gradeSort, 
          //         itemStyle: {
          //           color: '#d2e682'
          //         },
          //         barGap: '10%', 
          //     }
          //   ]
          // }
          // // 设置配置项并渲染
          // this.chart.setOption(option);
        },
        // 各类指标对比表初始化
        initIndicatorChart(chartList){

          // 窗口渲染结束后 插入图表
          this.$nextTick(() => {

            chartList.forEach((ele,index) => {
            let chartDom = this.$refs[`chart_${index}`]
            if (chartDom && chartDom[0]) {
              let chart = echarts.init(chartDom[0])
              // 配置项
              let option = {
                title: {
                  text: ele.hardName + '各类指标比对',  // 主标题
                },
                // 触发方式：'axis'坐标轴触发，'item'数据项触发
                tooltip: {
                  trigger: 'axis'  
                },
                // X轴配置
                xAxis: [
                  {
                    // 类目轴，适用于离散的类目数据
                    type: 'category',  
                    // 配置X轴名称
                    data: ele.scoreRange
                  }
                ],
                // Y轴配置
                yAxis: [
                  {
                    // 数值轴，适用于连续数据
                    type: 'value'  
                  }
                ],
                // 图例项，对应series中的name
                legend: {
                  data: [ele.legendHard, '年段指标']  
                },
                // 数值列表
                series: [
                  {
                    // 系列名称，与legend对应
                    name: ele.legendHard,
                    // 图表类型：柱状图
                    type: 'bar', 
                    // 数据数组 
                    data: ele.hardClassSort,
                    itemStyle: {
                      color: '#90cbfb'
                    },
                    barGap: '10%', 
                  },{
                      name: '年段指标',      
                      type: 'bar',           
                      data: ele.gradeSort, 
                      itemStyle: {
                        color: '#d2e682'
                      },
                      barGap: '10%', 
                  }
                ]
              }


              // 延时显示
              setTimeout(() => {
                chart.resize();
                chart.setOption(option);
              }, 10)

            }
          });
        
          })
        },
        // 分数段比较表
        step10Chart(){

          // 将考试json中的行政班与该老师的行政班进行比对，只显示老师配置的行政班
          let configHard = this.hardClassConfig.filter(item1 => 
            this.hardClassList.some(item2 => item2.hardName === item1.hard_name)
          )
          this.configHard = configHard
          if(configHard.length == 0)  return 

          let chartList = []
          configHard.forEach((ele,count) => {
            let hardName = ele.hard_name
            let item = this.hardClassList.find(item => item.hardName == hardName)
            let index = item.index
            // 获取当前选中的班级
            let legendHard = hardName + "分数段"
            let hardStep10 = this.hardClassStatistics[index].step10
            let gradeStep10 = this.jsonData.score_step10

            // 过滤排序
            let hardClassSort = hardStep10.map(item => item.count)
            let gradeSort  = gradeStep10.map(item => item.count)

            let option = {
                index: count,
                hardName: hardName,
                legendHard : legendHard,
                hardStep10: hardStep10,
                gradeSort: gradeSort,
                hardClassSort: hardClassSort
              }
              chartList.push(option)
          })
          
          this.chartList = chartList
          // 初始化多张图表
          this.initStep10Chart(chartList)

        },
        // 分数段比较表初始化
        initStep10Chart(chartList){

          // 窗口渲染结束后 插入图表
          this.$nextTick(() => {
            chartList.forEach((ele,index) => {
              let chartDom = this.$refs[`chart_${index}`]
              if (chartDom && chartDom[0]) {

                let chart = echarts.init(chartDom[0])
                // 配置项
                let option = {
                  title: {
                    text: ele.hardName + '各类指标比对',  
                  },
                  // 触发方式：'axis'坐标轴触发，'item'数据项触发
                  tooltip: {
                    trigger: 'axis'  
                  },
                  // X轴配置
                  xAxis: [
                    {
                      // 类目轴，适用于离散的类目数据
                      type: 'category',  
                      // 配置X轴名称
                      data: this.step10List
                    }
                  ],
                  // Y轴配置
                  yAxis: [
                    {
                      // 数值轴，适用于连续数据
                      type: 'value'  
                    }
                  ],
                  // 图例项，对应series中的name
                  legend: {
                    data: [ele.legendHard, '年级分数段']  
                  },
                  // 数值列表
                  series: [
                    {
                      // 系列名称，与legend对应
                      name: ele.legendHard,
                      // 图表类型：柱状图
                      type: 'bar', 
                      // 数据数组 
                      data: ele.hardClassSort,
                      itemStyle: {
                        color: '#90cbfb'
                      },
                      barGap: '10%', 
                    },{
                        name: '年级分数段',      
                        type: 'bar',           
                        data: ele.gradeSort, 
                        itemStyle: {
                          color: '#d2e682'
                        },
                        barGap: '10%', 
                    }
                  ]
                }
                // 延时显示
                setTimeout(() => {
                  chart.resize();
                  chart.setOption(option);
                }, 10)

            }
          })
          })
        },
        // 读取主客观题json
        loadingTiJson(){
          // 解读json
          // let analyse_oss_name = "answer/analyse/310/exam_hard_ti_310.json"
          // let analyse_oss_name = "answer/analyse/2883/exam_hard_ti_2883.json"
          let examId = this.form.examId
          let analyse_oss_name = "answer/analyse/" + examId + "/exam_hard_ti_" + examId + ".json"
          if(analyse_oss_name != null){
              analyse_oss_name = window.g.OSS_HOST + analyse_oss_name;
          }
          this.loading = true;
          // let that = this;
          axios.defaults.headers = {'Content-Type': 'application/json;charset=UTF-8'}
          axios({
              method:'get',
              url: `${analyse_oss_name}?t=${Date.now()}`
            }).then((res)=>{

              this.jsonHardData =  res.data

            })
        },
        // 主客观题过滤
        kgChart(){
          // 将班级和分数对应在一起
          let classList = this.configHard
          if(classList.length == 0) return

          classList.forEach((ele,index) => {
            // 行政班级
            let hardName = ele.hard_name
            if(index == 0) this.activeTab = hardName

            // 总题型列表
            let hardJson = this.jsonHardData 
            let tableName = hardName + "统计情况"
            let data  = hardJson[hardName]
            let kgResult = []
            let zgResult = []
            let topicResult= []
            data.forEach((item,index) => {

              let topic = {}
              if(item.t1 === "SingleChoice" || item.t1 === 'MultipleChoice' || item.t1 === 'Judge'){
                topic = {...item,
                  answers: Object.keys(item)
                        .filter(key => !['ix', 't1', 't2','score_rate'].includes(key))
                        .map(key => ({ anw: key, count: item[key] }))
                        .sort((a, b) => a.anw.localeCompare(b.anw))  // 按字母排序

                }
                kgResult.push(topic)
                topicResult.push(topic)
              }else {
                debugger
                // 主观题根据总分 十分以下默认显示全部，十分以上默认五分步长
                let topicList = this.jsonData.scores
                let ti = topicList[index]
                let right_score = ti.right_score
                let step = ''
                if(right_score != null || right_score != '' || right_score != undefined){
                  if(right_score > 10) step = '5'
                }

                // 主观题部分
                topic = {...item,
                  answers: Object.keys(item)
                        .filter(key => !['ix', 't1', 't2','score_rate'].includes(key))
                        .map(key => ({ anw: key, count: item[key] }))
                        .sort((a, b) => a.anw.localeCompare(b.anw))  // 按字母排序

                }
                topic.step = step
                topic.question_id = ti.question_id
                // 非默认步长情况下，进行一次步长处理
                if(step == '5'){
                  topic  = this.changeZgScore(topic,1)
                }

                zgResult.push(topic)
                topicResult.push(topic)
                // topic = {...item}
              }

              // hardResult.push(topic)

            });

            classList[index].kgData = kgResult
            classList[index].zgData = zgResult
            classList[index].topicResult = topicResult
            classList[index].tableName = tableName
            

            
          });

              // // 过滤单选多选的题目
              // let hardJson = this.jsonHardData 


              // this.tableName = this.hard.hardName + "统计情况"
              // // 筛选出单多选题
              // let data  = hardJson[this.hard.hardName]
              // const result = data
              //   .filter(item => item.t1 === "SingleChoice" || item.ti === 'MultipleChoice')
              //   .map(item => ({
              //       ...item,
              //       answers: Object.keys(item)
              //           .filter(key => !['ix', 't1', 't2','score_rate'].includes(key))
              //           .map(key => ({ anw: key, count: item[key] }))
              //           .sort((a, b) => a.anw.localeCompare(b.anw))  // 按字母排序
              //   }));

              //   this.tableData = result


        },
        // 题型分析
        scoreStatisticsChart(){
          debugger
          if(this.configHard.length == 0)  return 

          let chartList = []
          let configHard = this.configHard
          configHard.forEach((ele,count) => {

            // 直接显示全部的题目
            let hardName = ele.hard_name
            let data  = this.jsonHardData[hardName]
            let hard_score_rate = data
                // .filter(item => item.t1 === "SingleChoice" || item.t1 === 'MultipleChoice' || item.t1 === 'Judge')
                .map(item => item.score_rate)
                .reverse();

            let ti_list = data
                      // .filter(item => item.t1 === "SingleChoice" || item.t1 === 'MultipleChoice' || item.t1 === 'Judge')
                      .map(item => '第' + item.ix + '题')
                      .reverse();

            // let scores = this.jsonData.scores.filter(item => item.type =="SingleChoice" || item.type =="MultipleChoice"  || item.type =="Judge")
            let scores = this.jsonData.scores
            
            let join_count = this.jsonData.join_count

            // 年级的得分率
            let result = scores.map(item => {
              // 判断是主观题还是客观题
              if(item.type =="SingleChoice" || item.type =="MultipleChoice"  || item.type =="Judge"){
                let right_anw = item.right_anw
                let score = item.right_score
                // 过滤正确答案的人数(总的全部的数据)
                let r = item.anw_count.filter(i => i.anw == right_anw)
                if(r.length == 0) return 0
                let anw = item.anw_count.filter(i => i.anw == right_anw)[0]['count']
                // return anw / join_count;
                return  Math.round(anw / join_count * 100) / 100;
              }else{
                // 主观题的年段得分率 = 主观题的平均分 / 满分
                let avg = item.avg
                let r_s = item.right_score
                return  Math.round(avg / r_s * 100) / 100;

              }
            }).reverse();

            
            let option = {
                index: count,
                hardName: hardName,
                ti_list: ti_list,
                hard_score_rate : hard_score_rate,
                result: result,
              }
              chartList.push(option)

          })

          this.chartList = chartList
          // 初始化多张图表
          this.initScoreStatistics(chartList)

        },
        // 初始化题型分析
        initScoreStatistics(chartList){

          // 窗口渲染结束后 插入图表
          this.$nextTick(() => {
            chartList.forEach((ele,index) => {

            let chartDom = this.$refs[`chart_${index}`]
              if (chartDom && chartDom[0]) { 
      
                let chart = echarts.init(chartDom[0])

                // 配置项
                let option = {
                        title: {
                          text: ele.hardName  ,  
                        },
                        // 触发方式：'axis'坐标轴触发，'item'数据项触发
                        tooltip: {
                          trigger: 'axis'  
                        },
                        // X轴配置
                        yAxis: [
                          {
                            // 类目轴，适用于离散的类目数据
                            type: 'category',  
                            // 配置X轴名称
                            data: ele.ti_list
                          }
                        ],
                        // Y轴配置
                        xAxis: [
                          {
                            // 数值轴，适用于连续数据
                            type: 'value'  
                          }
                        ],
                        // 图例项，对应series中的name
                        legend: {
                          data: ["班级", '年级']  
                        },
                        // 数值列表
                        series: [
                          {
                            // 系列名称，与legend对应
                            name: "班级",
                            // 图表类型：柱状图
                            type: 'bar', 
                            // 数据数组 
                            data: ele.hard_score_rate,
                            itemStyle: {
                              color: '#90cbfb'
                            },
                            barGap: '10%', 
                          },{
                              name: '年级',      
                              type: 'bar',           
                              data: ele.result, 
                              itemStyle: {
                                color: '#ff8924'
                              },
                              barGap: '10%', 
                          }
                        ]
                }

                // chart.resize();
                // chart.setOption(option);

                // 延时显示
                setTimeout(() => {

                  chart.resize();
                  chart.setOption(option);


                  let that = this;
                  chart.off('click'); // 清除旧事件
                  chart.on('click',function(params){
                    debugger
                    // 获取指定班级的题目列表
                    let hardName = ele.hardName
                    let totalData = that.configHard
                    let filter  = totalData.filter(item=> item.hard_name ==  hardName)
                    if(filter.length == 0) return
                    // 获取到指定行政班的题型列表
                    let data = filter[0].topicResult
                    let num = params.name.replace(/[第题]/g, '')
                    // 获取到对应题目的客观题统计
                    let tableData = data[num -1]
                    this.topicTitle = hardName + "-" + params.name
                    this.topicStatisticsVisible = true
                    this.topicData = [tableData]

                  }.bind(this))
                  
                }, 10)
               
              }
            })
          })
                    


        },
        // 总结归纳下班级的值    
        getHardScoreData(sht, ck){

            this.scoreRange = [{name: "优秀", from: 90, to: 100}, {name: "及格", from: 60, to: 100},{name: "不及格", from: 0, to: 60}];
            let hardScores = this.jsonData.hard_scores;
            let fullScore = this.jsonData.full_score;
            this.hardClassList.forEach((hardName,index) =>{
     
              let fi = XEUtils.findIndexOf(hardScores, item => item.hardName==hardName);
              if(fi > -1){
                let h = hardScores[fi];
                sht.real.push(h.count);
                sht.total.push(h.totalScore);
                sht.avg.push( (h.totalScore/h.count).toFixed(2));
                sht.min.push(h.min);
                sht.max.push(h.max);
                sht.level10.push(h.step10);
                let ran = [];
                // scoreRange： 统计优秀，及格，不及格人数
                for (let j=0; j<this.scoreRange.length;j++){
     
                  let sr = this.scoreRange[j];
                  let mcount = 0;
                  let myTo = (sr.to==fullScore)?(sr.to+1):sr.to;
                  XEUtils.arrayEach(h.scores, (item, key) => {
                    if(item.score >= sr.from && item.score < myTo){
                      mcount = mcount + item.count;
                    }
                  })
                  ran.push({name: sr.name, count: mcount, lv: (mcount/h.count).toFixed(4)});
                }
                sht.range.push(ran);
              }

            })

            

        },
        // 区分优秀，及格，不及格等（利用总分算30%的区间）
        setScoreLevel(scoreCount,totalScore){
            let scoreForm = this.scoreLevels;
            // console.log("setScoreLevel", scoreForm)
            // let scoreCount = this.jsonData.score_count
            // let totalScore = this.examInfo.totalScore
            scoreForm.score0.from = 0
            scoreForm.score0.to = Math.ceil(totalScore*0.6)
            scoreForm.score60.from = Math.ceil(totalScore*0.6)
            scoreForm.score60.to = Math.ceil(totalScore*0.7)
            scoreForm.score70.from = Math.ceil(totalScore*0.7)
            scoreForm.score70.to = Math.ceil(totalScore*0.8)
            scoreForm.score80.from = Math.ceil(totalScore*0.8)
            scoreForm.score80.to = Math.ceil(totalScore*0.9)
            scoreForm.score90.from = Math.ceil(totalScore*0.9)
            scoreForm.score90.to = totalScore+1
            let list = scoreCount.score;
            let good90 = {name: "优秀(" + scoreForm.score90.from + "-" + scoreForm.score90.to + ")", count: 0};
            let good80 = {name: "良好(" + scoreForm.score80.from + "-" + scoreForm.score80.to + ")", count: 0};
            let good70 = {name: "中等(" + scoreForm.score70.from + "-" + scoreForm.score70.to + ")", count: 0};
            let good60 = {name: "及格(" + scoreForm.score60.from + "-" + scoreForm.score60.to + ")", count: 0};
            let good0 = {name: "不及格(" + scoreForm.score0.from + "-" + scoreForm.score0.to + ")", count: 0};
            let good_count = 0, up_count = 0, total_count = 0;

            for (let i=0; i< list.length; i++){
                let d = list[i];
                if(d >=scoreForm.score0.from && d < scoreForm.score0.to){
                    good0.count = good0.count + scoreCount.count[i];
                    good0.name = "不及格(" + scoreForm.score0.from + "-" + scoreForm.score0.to + ")";
                    total_count = total_count + scoreCount.count[i];
                }
                if(d >=scoreForm.score0.to && d < scoreForm.score60.to){
                    good60.count = good60.count + scoreCount.count[i];
                    good60.name = "及格(" + scoreForm.score60.from + "-" + scoreForm.score60.to + ")";
                    up_count = up_count + scoreCount.count[i];
                    total_count = total_count + scoreCount.count[i];
                }
                if(d >=scoreForm.score60.to && d < scoreForm.score70.to){
                    good70.count = good70.count + scoreCount.count[i];
                    good70.name = "中等(" + scoreForm.score70.from + "-" + scoreForm.score70.to + ")";
                    up_count = up_count + scoreCount.count[i];
                    total_count = total_count + scoreCount.count[i];
                }
                if(d >=scoreForm.score70.to && d < scoreForm.score80.to) {
                    good80.count = good80.count + scoreCount.count[i];
                    good80.name = "良好(" + scoreForm.score80.from + "-" + scoreForm.score80.to + ")";
                    up_count = up_count + scoreCount.count[i];
                    total_count = total_count + scoreCount.count[i];
                }
                if(d >=scoreForm.score80.to ) {
                    good90.count = good90.count + scoreCount.count[i];
                    good90.name = "优秀(" + scoreForm.score90.from + "-" + scoreForm.score90.to + ")";
                    up_count = up_count + scoreCount.count[i];
                    good_count = good_count + scoreCount.count[i];
                    total_count = total_count + scoreCount.count[i];
                }
            }
            // this.examCount.goodScale = Math.round(good_count/total_count *10000 )/100 ;
            // this.examCount.upScale = Math.round(up_count/total_count*10000)/100;
            // let levelList = [good90, good80, good70, good60, good0];
            // console.log("levelList", levelList)
            // this.setScoreLevelData(levelList);
        },
        rowStyle({ row, rowIndex }) {
          return {
            height: '100px'  // 设置行高
          }
        },
        // 读取教师的所属课程
        loadCourceList(){
          
            let search = {  licenceId: this.userInfo.licenceId, schoolId: mUtils.searchText(this.userInfo.schoolId)};
            let param = { controllerName: 'sclCource', methodName: '/listAll',param: search};
            return simpleApi.list(param).then(({result: {code, data}}) =>  {
                if (code == 0) {
                 this.courseList = data
                }
            }).catch((error) => {
                console.log("error",error)
            });
        },
        // 读取老师旗下指定课程的行政班列表
        loadMyClassList(){
          // let courseId = this.course.id
          let search = {  teacherId: this.userInfo.id};
          let param = { controllerName: 'teacherMyClass', methodName: '/myClassListAll',  param: search};
          return simpleApi.list(param).then(({result: {code, data}}) =>  {
            if (code == 0) {
              this.hardClassConfig = data
            }
          }).catch((error) => {
              console.log("error",error)
          });
        },
        // 懒加载函数
        async loadNode(node, resolve) {
          // 根节点 - 加载年级
          if (node.level === 0) {
            // const data = await this.fetchGrades()
            let result = await this.loadCourceList1()
            // 配置树组件布局
            const data = result.map(item => ({
              id: item.id,
              name: item.name,
              type: 'course',
              leaf: false
            }))
            resolve(data)
          }
          // 年级节点 - 加载班级
          else if (node.data.type === 'course') {
            let result = await this.loadMyClassList2(node.data.id)
            const data = result.map(item => ({
              id: item.hard_class_id,
              name: item.hard_name,
              type: 'hardClass',
              courseId: node.data.id,
              leaf: true
            }))
            resolve(data)
          }
          else {
            resolve([])
          }
        },
        // 点击节点
        handleNodeClick(data,checked) {
          // 判断点击到行政班节点时 查询对应的考试iD
          if(data.type == 'course'){
            let courseId = data.id
            // let courseId = data.courseId
            this.loadExamList(courseId)
          }



          // console.log('选中:', data)
          // if (checked) {
          //   // 选中时，清空其他所有选中
          //   this.$refs.treeRef.setCheckedKeys([data.id])
          // }
        },
        // 读取考试列表
        loadExamList(){
          // 结束状态的考试
          //,status:'2'
          let search = {  licenceId: this.userInfo.licenceId, teacherId: this.userInfo.id,orderBy:'id desc'};
          let param = { controllerName: 'akExam', methodName: '/selectExamByTeacherId', param: search};
          return simpleApi.list(param).then(({result: {code, data}}) =>  {
            this.examList = data
          })
        },
        // 读取教师的所属课程
        async loadCourceList1(){
          let search = {  licenceId: this.userInfo.licenceId, schoolId: mUtils.searchText(this.userInfo.schoolId)};
          let param = { controllerName: 'sclCource', methodName: '/listAll',param: search};
          return simpleApi.list(param).then(({result: {code, data}}) =>  {
              if (code == 0) {
               this.courseList = data
               return data
              }
          }).catch((error) => {
              console.log("error",error)
            });
        },
        // 读取老师旗下指定课程的行政班列表
        async loadMyClassList2(courseId){

          let search = {  teacherId: this.userInfo.id,courseId: courseId};
          let param = { controllerName: 'teacherMyClass', methodName: '/myClassListAll',  param: search};
          return simpleApi.list(param).then(({result: {code, data}}) =>  {
            if (code == 0) {
              this.hardClassList = data
              return data
            }
          }).catch((error) => {
              console.log("error",error)
          });
        },
        // 仅全屏
        openFull(value,type){
          this.fullScreenVisible = true
          // let that = this
          this.$nextTick(()=>{
            let old = null
            if(type == 1){
              old = echarts.getInstanceByDom(this.$refs[`chart_${value}`][0])
            }else{
              old = echarts.getInstanceByDom(this.$refs[`${value}`])
            }
            
            
            // 重置全屏图表 
            let oldFullChart = echarts.getInstanceByDom(this.$refs.fullChartRef)
            if (oldFullChart) {
                oldFullChart.dispose(); // 只销毁上一个全屏图表
            }
            let full = echarts.init(this.$refs.fullChartRef)
            full.setOption(old.getOption())
            window.onresize = ()=>full.resize()
          })
        },
        // 全屏但是加入题目弹窗
        openFullScreenAndDialog(index,hardName){
          this.fullScreenVisible = true
          // let that = this
          // 获取全屏数据
          let totalData = this.configHard
          let filter  = totalData.filter(item=> item.hard_name ==  hardName)
          if(filter.length > 0){
            this.fullData = filter[0]
          }else{
            this.fullData = {}
          }
          
          this.$nextTick(()=>{
            debugger
            let old = echarts.getInstanceByDom(this.$refs[`chart_${index}`][0])
            let full = echarts.init(this.$refs.fullChartRef)
            let option = old.getOption()
            // 全屏时把图表的柱子变粗点
            let series = option.series
            // series.forEach(ele => {
            //   ele.barWidth  = 10
            //   ele.barGap  = 50
            // });

            // option.yAxis[0].axisLabel.interval = 0
            // option.yAxis[0].axisLabel.show = true

            option.yAxis[0].axisLabel = {
              show: true,
              interval: 0,
              fontSize: 20,        
              lineHeight: 50,     
              margin: 15           
            }

            full.setOption(option)

            // 插入题型弹窗
            full.on('click',function(params){
              // 获取指定班级的题目列表
              
              let totalData = this.configHard
              let filter  = totalData.filter(item=> item.hard_name ==  hardName)
              if(filter.length == 0) return

              // 获取到指定行政班的题型列表
              let data = filter[0].topicResult

              let num = params.name.replace(/[第题]/g, '')
              // 获取到对应题目的客观题统计
              let tableData = data[num -1]
              this.topicTitle = hardName + "-" + params.name
              this.topicStatisticsVisible = true
              this.topicData = [tableData]

            }.bind(this))

            window.onresize = ()=>full.resize()
          })
        },
        // 调整步长
        changeZgScore(item,type){

          let value = item.step
          let newObj = {
            ix: item.ix,
            t1: item.t1,
            t2: item.t2
          }

          // let answer = item.answers
          
          // let ti_list = answer.sort((a, b) => parseFloat(a.anw) - parseFloat(b.anw))
          let ti_list =  Object.keys(item)
                        .filter(key => !['ix', 't1', 't2','answers','score_rate','step','question_id'].includes(key))
                        .map(key => ({ anw: key, count: item[key] }))
                        .sort((a, b) => parseFloat(a.anw) - parseFloat(b.anw))


          let step_level = value * 1

          // 找出最大最小的值
          if(ti_list.length >0){
            let min = ti_list[0].anw * 1
            let max = ti_list[ti_list.length -1].anw * 1

            let step = 0
            let list = []
            // 根据步长分区域
            while(step == 0 || step < max){
              let step_start = step
              let step_end = step + step_level
              let step_name = step_start + "~" + step_end

              // 根据步长的最大最小值范围 筛选总数
              let count = this.getCountInRange(ti_list,step_start,step_end)
              newObj[step_name] = count
              let option = {
                anw: step_name,
                count: count
              }
              list.push(option)
              step =  step + step_level
            }

            item.answers = list

            // item.answer.zgData = list
            // debugger
            // item = newObj
            if(type == 1) return item

          }else{
            return 
          }
        },
        // 累加主观题区间人数
        getCountInRange(scoreMap, min, max) {
          let total = 0

          // 遍历所有分数 key
          for (let keyStr in scoreMap) {

            let score = parseFloat(keyStr) // 转数字

            // 判断区间：min ≤ 分数 < max
            if (score >= min && score < max) {
              total += scoreMap[keyStr].count // 累加对应人数
            }
          }

          return total
        },
        // 根据 count 获取对应颜色
        getProgressColor(count) {
          let index = Math.min(Math.floor(count / 10), 9)
          return this.progressColors[index]
        },
        // 典型错题 将图表得分率最低十题显示
        typicalTopic(){

          // 判断全屏数据是否为空 
          if(JSON.stringify(this.fullData) !== '{}'){
            let data = this.fullData
            let topicResult = data.topicResult
            // 得分率从小到大排序后取最低的十题
            topicResult = topicResult.sort((a, b) => a.score_rate - b.score_rate).slice(0, 10)


            let hard_score_rate = topicResult.map(item => item.score_rate).reverse()

            let ti_list = topicResult.map(item => '第' + item.ix + '题').reverse()

            // 根据对应的题目 获取到年段的得分率
            let scores = this.jsonData.scores
            
            let join_count = this.jsonData.join_count
            // 年级的得分率
            let result = topicResult.map(ele => {
              let ix = ele.ix
              // 对应年段的值
              let item = scores[ix -1]

              // 判断是主观题还是客观题
              if(item.type =="SingleChoice" || item.type =="MultipleChoice"  || item.type =="Judge"){
                let right_anw = item.right_anw
                let score = item.right_score
                // 过滤正确答案的人数(总的全部的数据)
                let r = item.anw_count.filter(i => i.anw == right_anw)
                if(r.length == 0) return 0
                let anw = item.anw_count.filter(i => i.anw == right_anw)[0]['count']
                // return anw / join_count;
                return  Math.round(anw / join_count * 100) / 100;
              }else{
                // 主观题的年段得分率 = 主观题的平均分 / 满分
                let avg = item.avg
                let r_s = item.right_score
                return  Math.round(avg / r_s * 100) / 100;
              }

            }).reverse();


            let option = {
              hardName: data.hard_name,
              ti_list: ti_list,
              hard_score_rate: hard_score_rate,
              result: result
            }
            this.initFullScoreStatistics(option)


          }
        },
        // 全屏切换重新配置图图表
        initFullScoreStatistics(ele){
          // 全屏图表
          let full = echarts.init(this.$refs.fullChartRef)

          // 配置项
          let option = {
                  title: {
                    text: ele.hardName ,  
                  },
                  // 触发方式：'axis'坐标轴触发，'item'数据项触发
                  tooltip: {
                    trigger: 'axis'  
                  },
                  // X轴配置
                  yAxis: [
                    {
                      // 类目轴，适用于离散的类目数据
                      type: 'category',  
                      // 配置X轴名称
                      data: ele.ti_list
                    }
                  ],
                  // Y轴配置
                  xAxis: [
                    {
                      // 数值轴，适用于连续数据
                      type: 'value'  
                    }
                  ],
                  // 图例项，对应series中的name
                  legend: {
                    data: ["班级", '年级']  
                  },
                  // 数值列表
                  series: [
                    {
                      // 系列名称，与legend对应
                      name: "班级",
                      // 图表类型：柱状图
                      type: 'bar', 
                      // 数据数组 
                      data: ele.hard_score_rate,
                      itemStyle: {
                        color: '#90cbfb'
                      },
                      barGap: '10%', 
                    },{
                        name: '年级',      
                        type: 'bar',           
                        data: ele.result, 
                        itemStyle: {
                          color: '#ff8924'
                        },
                        barGap: '10%', 
                    }
                  ]
          }

          full.setOption(option)
          window.onresize = ()=>full.resize()

        },
        // 获取到对应考试的答题卡信息 提取出对应顺序的题目信息
        getScantron(){
          let param = { controllerName: 'exam/scantron', methodName: '/getSheetByExamId', param: { examId: this.form.examId}};
            simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
              debugger
              if(data != null){
                let topicCollections =JSON.parse(JSON.stringify(data.topicCollections))
                // 仅过滤被<p> 标签包裹的题目
                let regex = /<p>(.*?)<\/p>/g;
                let matches = [...topicCollections.matchAll(regex)];
                let title = matches.map(m => m[1]);
               
                // 过滤题区question_id 来对应题目
                let scores = this.jsonData.scores
                let questionList = [...new Set(
                  scores.map(item => item.question_id).filter(question_id => question_id && question_id !== '')
                )];
                let map = {}
                // 按顺序匹配题目
                questionList.forEach((element,index) => {
                  let ti = title[index]
                  map[element]  = ti
                });

                this.titleList = map
              }
              // this.scantronInfo = data

              
            });
        },
        // 进度条补齐长度
        formatNumber(count) {
          return `${count.toString()}个`;
          // 补零到固定宽度，如 15个 -> 15个， 4个 -> 04个
          // return `${count.toString().padStart(2, '')}个`;
        
          // 用空格补齐
          // return `${count.toString().padStart(3, ' ')}个`;
        },
        // 主观题显示对应题目
        getTitleName(row) {
          let question_id = row.question_id
          return this.titleList[question_id] || ""; 
          // 或者返回默认值：return this.typeMap[type] || '未知类型';
        },
        // 班级综合分析
        comprehensiveAnalysis(){

          // 选中默认行政班 并初始化对应的图表
          let hardName = null

          // this.activeTabClass = null
          if(this.activeTabClass == null || this.activeTabClass == '0' || this.activeTabClass == '' || this.activeTabClass == undefined){
            if(this.configHard.length > 0){
              hardName = this.configHard[0].hard_name
              this.activeTabClass = hardName
              
            }
          }else{
            hardName = this.activeTabClass 
          }
          // 过滤班级卡片
          this.filterClass(hardName)
          // 成绩分布直方图
          this.step10ChartClass(hardName)
          // 学业等级结构
          this.academicLevel(hardName)
          // 与年级对比分析
          this.compareChar(hardName)
          
          

        },
        // 分数段比较表
        step10ChartClass(hardName){
          // 根据选中的行政班 生成图表
            let item = this.hardClassList.find(item => item.hardName == hardName)
            let index = item.index
            // 获取当前选中的班级
            let legendHard = hardName + "分数段"
            let hardStep10 = this.hardClassStatistics[index].step10
            let gradeStep10 = this.jsonData.score_step10

            // 过滤排序
            let hardClassSort = hardStep10.map(item => item.count)
            let gradeSort  = gradeStep10.map(item => item.count)

            let option = {
                // index: count,
                hardName: hardName,
                legendHard : legendHard,
                hardStep10: hardStep10,
                gradeSort: gradeSort,
                hardClassSort: hardClassSort
              }


   
          // 初始化图表
          this.initStep10ChartOne(option)

        },
        // 分数段比较表初始化
        initStep10ChartOne(ele){
          debugger
          let chartDom = this.$refs[`score`]

          if (chartDom ) {
            let chart = echarts.init(chartDom)
            // 配置项
            let option = {
              title: {
                text: ele.hardName + '成绩分布直方图',  
              },
              // 触发方式：'axis'坐标轴触发，'item'数据项触发
              tooltip: {
                trigger: 'axis'  
              },
              // X轴配置
              xAxis: [
                {
                  // 类目轴，适用于离散的类目数据
                  type: 'category',  
                  // 配置X轴名称
                  data: this.step10List
                }
              ],
              // Y轴配置
              yAxis: [
                {
                  // 数值轴，适用于连续数据
                  type: 'value'  
                }
              ],
              // 图例项，对应series中的name
              legend: {
                data: [ele.legendHard, '年级分数段']  
              },
              // 数值列表
              series: [
                {
                  // 系列名称，与legend对应
                  name: ele.legendHard,
                  // 图表类型：柱状图
                  type: 'bar', 
                  // 数据数组 
                  data: ele.hardClassSort,
                  itemStyle: {
                    color: '#90cbfb'
                  },
                  barGap: '10%', 
                },{
                    name: '年级分数段',      
                    type: 'bar',           
                    data: ele.gradeSort, 
                    itemStyle: {
                      color: '#d2e682'
                    },
                    barGap: '10%', 
                }
              ]
            }

            // 延时显示
            setTimeout(() => {
              chart.resize();
              // 设置配置项并渲染
              chart.setOption(option);
            }, 10)

          }
        },
        // 学业等级结构(A/B/C/D/E)
        academicLevel(hardName){
          let hard_scores_list = this.jsonData.hard_scores

          // 根据选中的行政班 生成图表
          let item = hard_scores_list.find(item => item.hardName == hardName)

          // 获取当前选中的班级
          let legendHard = hardName + "学业等级结构"
          let scoreLevels = item.scoreLevels

          let level ={
            "优秀": {
              level_name: 'A',
              itemStyle: "color: '#10b981'"
            },
            "良好": {
              level_name: 'B',
              itemStyle: "color: '#3b82f6'"
            },
            "中等": {
              level_name: 'C',
              itemStyle: "color: '#f59e0b'"
            },
            "及格": {
              level_name: 'D',
              itemStyle: "color: '#f97316'"
            },
            "不及格": {
              level_name: 'E',
              itemStyle: "color: '#ef4444'"
            },
          }
          let data = []
          scoreLevels.forEach((ele,index) =>{
            // { value: 8, name: 'A等(优秀)', itemStyle: { color: '#10b981' } },
            let name = level[ele.name].level_name + '(' +  ele.name + ')'
            let params = {
              name: name,
              value: ele.count,
              itemStyle: level[ele.name].itemStyle

            }
            data.push(params)
          })


          let chartDom = this.$refs[`studentLevel`]

          if (chartDom ) {
            let chart = echarts.init(chartDom)
            

            let option = {
              title: {
                text: legendHard,  
              },
              tooltip: {
                trigger: 'item'
              },
              legend: {
                bottom: 0,
                left: 'center'
              },
              series: [
                {
                  name: '学业等级',
                  type: 'pie',
                  radius: ['40%', '70%'],
                  itemStyle: {
                    borderRadius: 4,
                    borderColor: '#fff',
                    borderWidth: 2
                  },
                  label: {
                    show: false
                  },
                  data: data
                  // [
                  //   { value: 8, name: 'A等(优秀)', itemStyle: { color: '#10b981' } },
                  //   { value: 29, name: 'B等(良好)', itemStyle: { color: '#3b82f6' } },
                  //   { value: 25, name: 'C等(中等)', itemStyle: { color: '#f59e0b' } },
                  //   { value: 16, name: 'D等(及格)', itemStyle: { color: '#f97316' } },
                  //   { value: 4, name: 'E等(不及格)', itemStyle: { color: '#ef4444' } }
                  // ]
                }
              ]
            }
            // 延时显示
            setTimeout(() => {
              chart.resize();
              chart.setOption(option);
            }, 10)

          }

        },
        // 与年级对比分析
        compareChar(hardName){
          let hard_scores_list = this.jsonData.hard_scores

          // 根据选中的行政班 生成图表
          let item = hard_scores_list.find(item => item.hardName == hardName)

          // 获取当前选中的班级
          let legendHard = hardName + "学业等级结构"
          let scoreLevels = item.scoreLevels
          let classInfo = this.classInfo
          let gradInfo = this.gradInfo
          //  班级/年段 平均分
          let grade_avg = gradInfo.avg
          let class_avg = classInfo.avg

          // 及格率
          let grad_pass = gradInfo.pass_rate
          let class_pass = classInfo.pass_rate

          // 优秀率 
          let grade_excellent = gradInfo.excellent_rate
          let class_excellent = classInfo.excellent_rate

          // 最高分 
          let grade_max = gradInfo.max
          let class_max = classInfo.max

          let chartDom = this.$refs[`compare`]
          if (chartDom ) {
            let chart = echarts.init(chartDom)

            // 配置项
            let option = {
                title: {
                  text: legendHard,  
                },
                tooltip: {
                  trigger: 'axis'  
                },
                // X轴配置
                xAxis: [
                  {
                    type: 'category',  
                    // 配置X轴名称
                    data: ['平均分', '及格率', '优秀率', '最高分'],
                  }
                ],
                // Y轴配置
                yAxis: [
                  {
                    type: 'value'  
                  }
                ],
                legend: {
                  data: [hardName, '年级分数段']  
                },
                // 数值列表
                series: [
                  {
                    name: hardName,
                    // 图表类型：柱状图
                    type: 'bar', 
                    // 数据数组 
                    data: [class_avg,class_pass,class_excellent,class_max],
                    itemStyle: {
                      color: '#90cbfb'
                    },
                    barGap: '10%', 
                  },{
                      name: '年级分数段',      
                      type: 'bar',           
                      data: [grade_avg,grad_pass,grade_excellent,grade_max], 
                      itemStyle: {
                        color: '#d2e682'
                      },
                      barGap: '10%', 
                  }
                ]
            }

            // 延时显示
            setTimeout(() => {
              chart.resize();
              chart.setOption(option);
            }, 10)
            
          }

          let cardList = this.cardClassList
          cardList.forEach(ele => {
            let title = ele.title
            if(title == '班级均分'){
              ele.value = class_avg
            }else if (title == '班级最高分'){
              ele.value = class_max
            }
          });




        },
        // 过滤年段的
        filterGrade(){
          let gradInfo = {}
          let jsonData = this.jsonData

          // 年段均分
          let avg = jsonData.score_avg
          gradInfo.avg = avg

          // 最高分
          let max =  jsonData.score_max
          gradInfo.max = max

          // 最低分
          let score_count = jsonData.score_count
            // 直接取第一个(已倒序)
            let min = 0
            if(score_count.score.length >0) min = score_count.score[0]
            gradInfo.min = min

          // 标准差 
          let standardDeviation = jsonData.std.toFixed(2)
          gradInfo.standardDeviation = standardDeviation

          let score_level = jsonData.score_level
          let top = score_level.find(item => item.name == "优秀")
          let bottom = score_level.find(item => item.name == "不及格")
          // 考试总人数
          let join_count = jsonData.join_count

          // 及格率
          let pass = (1 - bottom.count / join_count) * 100 
          let pass_rate = pass.toFixed(2)
          gradInfo.pass_rate = pass_rate

          // 优秀率(>= 90)
          let excellent = top.count / join_count
          let excellent_rate = excellent.toFixed(2)
          gradInfo.excellent_rate = excellent_rate


          this.gradInfo = gradInfo
          // debugger
          this.insertCard(this.cardGradeList,gradInfo)
        },
        // 过滤班级的
        filterClass(hardName){
          let hard_scores_list = this.jsonData.hard_scores

          // 根据选中的行政班 生成图表
          let item = hard_scores_list.find(item => item.hardName == hardName)
          let classInfo = {}

          // 班级均分
          let avg = item.avg.toFixed(2)
          classInfo.avg = avg

          // 最高分
          let max = item.max.score
          classInfo.max = max

          // 最低分
          let min = item.min.score
          classInfo.min = min

          // 标准差
          let standardDeviation = 0
          if('std' in item) standardDeviation = item.std.toFixed(2)
          classInfo.standardDeviation = standardDeviation


          let join_count = item.count
          let score_level = item.scoreLevels
          let top = score_level.find(item => item.name == "优秀")
          let bottom = score_level.find(item => item.name == "不及格")

          // 及格率
          let pass = (1 - bottom.count / join_count) * 100 
          let pass_rate = pass.toFixed(2)
          classInfo.pass_rate = pass_rate

          // 优秀率(>= 90)
          let excellent = top.count / join_count
          let excellent_rate = excellent.toFixed(2)
          classInfo.excellent_rate = excellent_rate

          this.classInfo = classInfo

          this.insertCard(this.cardClassList,classInfo)


        },
        // 注入卡片信息
        insertCard(cardList,info){
          cardList.forEach((ele,index) =>{
            let title = ele.title
            if(title.includes('均分')){
              ele.value = info.avg
            }else if (title.includes('最高分')){
              ele.value = info.max
            }else if (title.includes('最低分')){
              ele.value = info.min
            }else if (title.includes('标准差')){
              ele.value = info.standardDeviation
            }else if (title.includes('及格率')){
              ele.value = info.pass_rate
            }else if (title.includes('优秀率')){
              ele.value = info.excellent_rate
            }
          })

        },
        // 点击切换()
        handleTabClick(){
          this.comprehensiveAnalysis()
        }

    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

.fullscreen-layout {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999; /* 确保在最上层 */
  background: #fff; /* 或其他背景色 */
  overflow: auto;
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* 让所有按钮水平居中 */
  gap: 30px; /* 按钮间距 */
  padding: 20px 0; /* 上下内边距 */
  justify-content: center;
}

.normal {
  background: #f0f0f0;
  color: #333;
}

.active {
  background: #007bff;
  color: white;
  border-color: #0056b3;
  box-shadow: 0 2px 5px rgba(0,123,255,0.3);
}

.progress-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.label-kg {
  // margin-right: 10px;
  min-width: 20px;
  // width: 60px;  /* 固定宽度，根据最长文字调整 */
  // margin-right: 10px;
  text-align: left;  /* 右对齐更美观 */
  flex-shrink: 0;
}
.label-zg {
  // margin-right: 10px;
  min-width: 50px;
  // width: 60px;  /* 固定宽度，根据最长文字调整 */
  margin-right: 10px;
  text-align: left;  /* 右对齐更美观 */
  flex-shrink: 0;
}

.progress-bar {
  flex: 1;
}

.chart {
  width: 100%;
  height: 50vh;  /* 必须是固定数值，不能用百分比 */
  /* 或者 */
  min-height: 400px;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);  /* 一行两个，等宽 */
  gap: 20px;  /* 卡片间距 */
  padding: 20px;
}

.chart-card {
  position: relative; /* 让按钮相对于卡片定位 */
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.chart-full-btn {
  position: absolute;
  top: 12px;    /* 距离顶部 */
  right: 12px;  /* 距离右侧 */
  z-index: 10;  /* 保证在图表上方 */
  background: rgba(255,255,255,0.9);
  border-radius: 4px;
}
// .chart-card h3 {
//   margin: 0 0 16px 0;
//   text-align: center;
//   font-size: 16px;
//   color: #333;
// }

// .chart {
//   width: 100%;
//   height: 400px;
// }

.container {
    padding: 20px;
    background-color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  }

  /* 标题栏 */
  .header-title {
    display: flex;
    align-items: center;
    border-bottom: 2px solid #3b82f6;
    padding-bottom: 10px;
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .tag-title {
    background-color: #3b82f6;
    color: #ffffff;
    padding: 4px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    margin-right: 12px;
  }
  
  .main-title {
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
  }

  /* 数据卡片行 */
  .card-row {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
  }
  
  .stat-card {
    flex: 1;
    background-color: #f8fafc;
    border-radius: 8px;
    padding: 20px;
    border-left: 4px solid;
  }
  
  /* 卡片边框颜色 */
  .card-blue { border-left-color: #3b82f6; }
  .card-green { border-left-color: #10b981; }
  .card-red { border-left-color: #ef4444; }
  .card-yellow { border-left-color: #f59e0b; }

  .card-title {
    font-size: 16px;
    color: #475569;
    margin-bottom: 8px;
    font-weight: 500;
  }
  
  .card-value {
    font-size: 32px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
  }
  
  .card-desc {
    font-size: 14px;
    color: #64748b;
    line-height: 1.5;
  }
  
  .card-desc.red {
    color: #ef4444;
  }


  /* 图表行 */
 .chart-row {
    display: flex;
    gap: 20px;
  }
  
  .chart-card {
    flex: 1;
    background-color: #fafafa;
    border-radius: 8px;
    padding: 16px;
  }
  
  .chart-title {
    text-align: left; 
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    margin: 0 0 16px 0;
  }
  
  .chart-container {
    width: 100%;
    height: 300px;
  }

  // 独占整个图表区域
  .chart-card-full {
    flex: 1;       
    width: 100%;
    background: #fff;
    border-radius: 8px;    /* 圆弧 */
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);  /* 阴影 */
    padding: 16px;
  }


    /* 仅当前页面 大号标签文字 */
  .large-tab .el-tabs__item {
    font-size: 16px !important; /* 自己调整大小 */
  }

  /* 选中状态 */
  .large-tab .el-tabs__item.is-active {
    font-size: 16px !important;
    font-weight: bold;
  }

</style>


